module.exports = __webpack_public_path__ + "static/img/img_3.58342797.jpg";